import React from "react";
import Footer from "../../Footer/Footer";
// import "../style/style-2.6.0.css";
import "../style/minimal_style.css";
import NavBar1 from "../../Navbar1/NavBar1";
export default function ShippingPolicy() {
  return (
    <>
      <Footer>
        <NavBar1 />
        <main id="main">
          <div class="container">
            <div class="page-header">
              <h1 class="page-title">Shipping Policy</h1>
            </div>
            <div class="page-content">
              <p>
                Your Shipping is very important to us. Accordingly, we have
                developed this Policy in order for you to understand how we
                collect, use, communicate and disclose and make use of personal
                information. The following outlines our Shipping policy.
              </p>
              <ul>
                <li>
                  Once we receive your order, we dispatch the product/s within 1
                  or 2 days. It usually takes 3-5 working days for the product
                  to get delivered.
                </li>
                <li>
                  To ensure that your order reaches you in the fastest time and
                  in good condition, we only ship through reputed courier
                  agencies..
                </li>
                <li>
                  We ship through leading courier services and you can track
                  your order online after it is shipped.
                </li>
                <li>
                  We ship on all working days except Sunday and public holidays.
                  Orders placed on Saturday would be dispatched from our
                  processing centre only on Monday.
                </li>
                <li>
                  We are not responsible for any delay caused by any unforeseen
                  time lags by the courier companies in delivering the goods to
                  the customer.
                </li>
                <li>
                  Once your order has been processed, you will receive a
                  shipment notification email with an estimated delivery date.
                  This is calculated based on distance from the warehouse
                  location to your address. Please ensure you provide the
                  correct contact details and delivery address.
                </li>
              </ul>

              <p>
                We strive to deliver your order accurately, in good condition
                and on time. All goods will be fully insured by us until they
                reach you, so your purchase is 100% safe.
              </p>
              <p>
                If you believe that the product is not in good condition, or if
                the packaging is tampered with or damaged, before accepting
                delivery of the goods, please refuse to take delivery of the
                package, and call our Customer Care +91- 084518 67144 or at
                support@k5fitness.in mentioning your order reference number.
                Photographs of the delivered product may also be sent to us. We
                shall handle such issues directly with the respective courier
                company..
              </p>
            </div>
          </div>
        </main>
      </Footer>
    </>
  );
}
